const adminRoutes = [
  {
    path: "/admin",
    name: "admin.index",
    component: () => import("@/modules/admin/views/AdminIndexPage.vue"),
    meta: {
      pageTitle: "Administração",
      roles: [1, 2, 5, 6],
      breadcrumb: [
        { text: "Administração", active: true }
      ]
    }
  },
  {
    path: "/admin/notifications",
    name: "admin.notifications.index",
    component: () => import("@/modules/admin/views/NotificationsPage.vue"),
    meta: {
      pageTitle: "Notificações",
      roles: [1, 2, 5, 6],
      breadcrumb: [
        { text: "Administração", to: { name: "admin.index" } },
        { text: "Notificações", active: true }
      ]
    }
  },
  {
    path: "/admin/notifications/orders",
    name: "admin.notifications.orders",
    component: () => import("@/modules/admin/views/OrderNotificationsPage.vue"),
    meta: {
      pageTitle: "Notificações de Pedidos",
      roles: [1, 2, 5, 6],
      breadcrumb: [
        { text: "Administração", to: { name: "admin.index" } },
        { text: "Notificações", to: { name: "admin.notifications.index" } },
        { text: "Notificações de Pedidos", active: true }
      ]
    }
  }
];

export default adminRoutes;
